<template>
  <AppMain></AppMain>
</template>

<script>
  export default {
    name: 'app-root',
  };
</script>



// WEBPACK FOOTER //
// src/AppRoot.vue